export const environment = {
  production: true,
  apiUrl: 'https://tpic-examcenter-api.azurewebsites.net', //http://localhost:8080  https://tpic-examcenter-api.azurewebsites.net
  clientId: 'YH',
  enableOnlineSupport: false,
  defaultLanguage: 'zh-TW', // YH 站台使用繁體中文
};
